<template>
  <div class="SADashboardAnalytics">
    <MobileNav :page_title="nav_title"></MobileNav>

    <div class="sideBarSection">
      <PlainSideBar v-if="isDesktop"></PlainSideBar>
    </div>

    <div v-if="isDesktop">
      <!-- v-if="user_details && user_details.is_active_ra" -->
      <div class="cover-page-container">
        <!-- Heading section -->
        <div class="flex-space-between user-details-section">
          <div class="label-lg-black-bold">
            <span class="crown-outer">
              <img
                src="../assets/images/RA-dashboard/Active RA - Crown Icon.svg"
                alt=""
              />
            </span>
            User Details
          </div>

         <div class="flex" style="margin-top: 7px; align-items: baseline; justify-content: end;">
  <el-button
    class="download-btn export-btn flex"
    @click="handleExportBasedOnTab"
    :disabled="isExportDisabled"
    :loading="is_export_Loading"
  >
    <span style="position: relative; top: -2px;">
      Export
      <i
        class="el-icon-document"
        style="font-size: 20px; margin-left: 3px; position: relative; top: 2px;"
      ></i>
    </span>
  </el-button>
</div>

        </div>

        <!-- Table filter section -->
        <div class="filter-section">
          <el-row :gutter="15" style="align-items: center;">
            <!-- <el-col :xs="24" :sm="2" :md="2" :lg="2" :xl="2">
              <div
                class="label-xs-bold right-margin-15"
                style="margin-top: 11px;"
              >
                Sort By:
              </div>
            </el-col> -->
            <el-col :xs="24" :sm="22" :md="22" :lg="22" :xl="22">
              <div class="flex-space-between">
                <div class="flex">
                  <div>
                    <div class="input-label-bold-gray">
                      Filter By:
                    </div>
                    <div class="flex">
                      <el-input
                        v-model="searchQuery"
                        size="mini"
                        placeholder="Email, Mobile"
                        clearable
                        style="width: 200px; margin-right: 18px;"
                        @input="filterUserData()"
                      ></el-input>
                    </div>
                  </div>
                  <div style="margin-right:20px">
                    <div class="input-label-bold-gray">
                      Past Duration:
                    </div>
                    <div class="flex">
                      <el-date-picker
                        v-model="startDate"
                        type="date"
                        placeholder="Start Date"
                        style="width: 125px; margin-right: 18px;"
                        size="mini"
                        class="custom-date-picker"
                        :default-value="defaultStartDate"
                        :picker-options="startDatePickerOptions"
                        @change="handleStartDateChange"
                      ></el-date-picker>
                      <el-date-picker
                        v-model="endDate"
                        type="date"
                        placeholder="End Date"
                        style="width: 125px"
                        size="mini"
                        class="custom-date-picker"
                        :default-value="defaultEndDate"
                        :picker-options="endDatePickerOptions"
                        @change="handleEndDateChange"
                      ></el-date-picker>
                    </div>
                  </div>

                  <div>
                    <div class="input-label-bold-gray">
                      Plan Status:
                    </div>
                    <div class="flex">
                      <el-select
                        v-model="status"
                        size="mini"
                        placeholder="Status"
                        style="width: 90px; margin-right: 18px;"
                        clearable
                        @change="filterUserData()"
                      >
                        <el-option
                          v-for="status in status_list"
                          :key="status.value"
                          :label="status.label"
                          :value="status.value"
                        >
                        </el-option>
                      </el-select>

                      <!-- <el-button
                        size="mini"
                        class="btn-light-blue-filled"
                        @click="filterUserData()"
                        >Show Result</el-button
                      > -->
                    </div>
                  </div>
                  <!-- <div>
                    <div class="input-label-bold-gray">
                      Asset Class:
                    </div>
                    <div class="flex">
                      <el-select
                        v-model="status"
                        size="mini"
                        placeholder="Status"
                        style="width: 130px; margin-right: 18px;"
                        @change="filterUserData()"
                      >
                        <el-option
                          v-for="status in status_list"
                          :key="status.value"
                          :label="status.label"
                          :value="status.value"
                        >
                        </el-option>
                      </el-select>

                    </div>
                  </div> -->
                  <div>
                    <div class="input-label-bold-gray">Brokers:</div>
                    <div class="flex">
                      <el-select
                        v-model="selectedBroker"
                        size="mini"
                        placeholder="Select Broker"
                        clearable
                        filterable
                        style="width: 120px; margin-right: 18px;"
                        @change="filterUserData()"
                      >
                        <el-option
                          v-for="(broker, index) in brokerList"
                          :key="index"
                          :label="broker"
                          :value="broker"
                        >
                          {{ broker }}
                        </el-option>
                      </el-select>
                    </div>
                  </div>

                  <!-- <div>
                    <div class="input-label-bold-gray">
                      KYC Status:
                    </div>
                    <div class="flex">
                      <el-select
                        v-model="kycStatus"
                        size="mini"
                        placeholder="KYC Status"
                        clearable
                        style="width: 130px; margin-right: 18px;"
                        @change="filterUserData()"
                      >
                        <el-option
                          v-for="kyc in kyc_status_list"
                          :key="kyc"
                          :label="kyc"
                          :value="kyc"
                        ></el-option>
                      </el-select>
                    </div>
                  </div> -->

                  <div style="margin-top:30px;border-radius:10px; ">
                    <el-button
                      size="mini"
                      @click="clearFilters()"
                      style="border-radius: 10px;padding: 3px 10px;color:rgb(64, 158, 255);border-color:rgb(64, 158, 255);"
                      :disabled="isFilterActive() == false"
                    >
                      Reset
                    </el-button>
                  </div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="15" style="align-items: center;">
            <el-col :xs="24" :sm="22" :md="22" :lg="22" :xl="22">
              <div>
                <div class="input-label-bold-gray">
                  Plan Name:
                </div>
                <div class="flex">
                  <el-select
                    v-model="subscribedPlans"
                    size="mini"
                    placeholder="Plans"
                    clearable
                    style="width: 105px; margin-right: 18px;"
                    @change="filterUserData()"
                  >
                    <el-option
                      subscribedPlans
                      v-for="plans in plan_name_list"
                      :key="plans"
                      :label="plans"
                      :value="plans"
                    ></el-option>
                  </el-select>

                  <!-- <el-button
                        size="mini"
                        class="btn-light-blue-filled"
                        @click="filterUserData()"
                        >Show Result</el-button
                      > -->
                </div>
              </div>
            </el-col>
          </el-row>
          <div class="button-row">
    <div class="button-group">
      <button
        v-for="btn in buttons"
        :key="btn.label"
        :class="['btn', { active: activeBtn === btn.name }]"
        @click="activeBtn = btn.name"
      >
        {{ btn.label }}
      </button>
    </div>
  </div>
        </div>

      <!-- Table for Login & Premium tab -->
        <div
          v-if="(activeBtn === 'login' || activeBtn === 'premium') && (subscribedUsersList.length || is_user_list_loading)" v-loading="is_user_list_loading"
        >
          <div class="board-table-outer">
            <table class="outer-board-table board-table">
              <thead>
                <tr class="main-head">
                  <th v-if="activeBtn === 'premium'">Invoice</th>
                  <th style="min-width: 150px;">Name</th>
                  <th style="min-width: 150px;">UTM Source</th>
                  <th style="min-width: 150px;">Email</th>
                  <th style="min-width: 90px;">Mobile</th>
                  <!-- <th style="min-width: 70px;">Pan</th> -->
                  <th style="min-width: 120px;" v-if="activeBtn === 'login'">First Login</th>
                  <th style="min-width: 120px;" @click="sortByLastLogin" v-if="activeBtn === 'login'">
                    Last Login
                    <span>
                      <i
                        v-if="sortOrder === 'asc'"
                        class="el-icon-arrow-up"
                        style="color: black ;"
                      ></i>
                      <i
                        v-else
                        class="el-icon-arrow-down"
                        style="color: black;"
                      ></i>
                    </span>
                  </th>
                  <th style="min-width: 130px;" v-if="activeBtn === 'premium'">First Subscribed</th>
                  <th style="min-width: 130px;" v-if="activeBtn === 'premium'">Latest Subscribed</th>
                  <th style="min-width: 120px; white-space: normal;"  v-if="activeBtn === 'login'">
                    Number of times user Login
                  </th>
                  <th style="min-width: 90px; white-space: normal;"  v-if="activeBtn === 'login'">
                    Number of Device Used
                  </th>
                  <th style="min-width: 90px; white-space: normal;"  v-if="activeBtn === 'premium'">
                    Number of Subscription
                  </th>
                  <th style="white-space: normal;"  v-if="activeBtn === 'premium'">
                    Price
                  </th>
                  <th style="min-width: 90px; white-space: normal;"  v-if="activeBtn === 'premium'">
                    Access Code Used (Count)
                  </th>
                  <th style="min-width: 150px; white-space: normal;"  v-if="activeBtn === 'premium'">
                    Brokers Connected
                  </th>
                  <th
                    style="min-width: 50px; color:#4488d0"
                    class="text-center fixed-column"
                  >
                    WhatsApp
                    <span class="shadow"></span>
                  </th>
                </tr>
              </thead>
              <tbody>
                <template v-for="data in subscribedUsersList">
                  <!-- First Table Row -->
                  <tr>
<td v-if="activeBtn === 'premium'">
  <a
    v-if="data.invoice_url"
    :href="data.invoice_url"
    target="_blank"
    class="external-link-color"
    style="text-decoration: underline;"
  >
    {{ data.invoice_no }}
  </a>
  <span v-else>--</span>
</td>

                    <td>{{ data.user_name || "--" }}</td>
                    <td>{{ data.utm_source || "--" }}</td>
                    <td>
                      <div
                        @click="handleEmailClick(data.email)"
                        v-if="data.email"
                        class="external-link-color"
                        style="text-decoration: underline; cursor: pointer;"
                      >
                        {{ data.email }}
                      </div>
                      <div v-else>--</div>
                    </td>
                    <td>{{ data.mobile || "--" }}</td>
                    <!-- <td>{{ data.pan_number || "--" }}</td> -->
                    <td v-if="activeBtn === 'login'">
                      {{
                        data.user_first_login
                          ? moment(data.user_first_login).format(
                              "MMM DD YYYY, h:MM A"
                            )
                          : "--"
                      }}
                    </td>
                    <td v-if="activeBtn === 'login'">
                      {{
                        data.user_last_login
                          ? moment(data.user_last_login).format(
                              "MMM DD YYYY, h:MM A"
                            )
                          : "--"
                      }}
                    </td>
                    <td v-if="activeBtn === 'premium'">
                      {{
                        data.first_subscription_datetime
                          ? moment(data.first_subscription_datetime).format(
                              "MMM DD YYYY, h:MM A"
                            )
                          : "--"
                      }}
                    </td>
                    <td v-if="activeBtn === 'premium'">
                      {{
                        data.latest_subscription_datetime
                          ? moment(data.latest_subscription_datetime).format(
                              "MMM DD YYYY, h:MM A"
                            )
                          : "--"
                      }}
                    </td>
                    <td type="text" style="text-align: center" v-if="activeBtn === 'login'">
                      {{ data.no_of_logins || "--" }}
                    </td>
                    <td v-if="activeBtn === 'login'"
                      @click="openDialogWithDeviceData(data.user_id)"
                      type="text"
                      class="external-link-color"
                      :style="{
                        textAlign: 'center',
                        cursor: data.user_id ? 'pointer' : 'default',
                        fontWeight: 'bold',
                        textDecoration: data.no_of_device_used
                          ? 'underline'
                          : 'none',
                      }"
                    >
                      {{ data.no_of_device_used || "--" }}
                    </td>    
                     <td type="text" style="text-align: center" v-if="activeBtn === 'premium'">
                      {{ data.no_of_times_subscribed_earlier || "--" }}
                    </td>  
                    <td type="text" style="text-align: center" v-if="activeBtn === 'premium'">
                      {{ data.plan_amount || "--" }}
                    </td>    
                    <td type="text" style="text-align: center" v-if="activeBtn === 'premium'">
                      {{ data.access_code_used_count || "--" }}
                    </td>    
                    <td type="text" style="text-align: center" v-if="activeBtn === 'premium'">
                     <span v-if="data.brokers_connected && data.brokers_connected.length">
                     <span v-for="(broker, index) in data.brokers_connected" :key="index">
                     {{ broker }}<span v-if="index !== data.brokers_connected.length - 1">, </span>
                    </span>
                    </span>
                    <span v-else>--</span>
                    </td>              
                    <td class="flex-center fixed-column">
                      <img
                        src="../assets/images/whatsapp.png"
                        width="25px"
                        alt=""
                        @click="openWhatsApp(data.mobile)"
                      />
                      <span class="shadow"></span>
                    </td>
                  </tr>

                  <!-- Second Row for Invoices only visible when expandedPlanId matches -->
                  <tr v-if="expandedPlanId === data.plan_id">
                    <td colspan="11" class="sub-section">
                      <div class="sub-sec-head" style="width:100%">
                        Advisory Services
                      </div>
                      <div class="table-padding">
                        <div class="text-left bottom-margin-15 font-weight-600">
                          from:
                        </div>
                        <div class="inner-table"></div>

                        <table
                          class="outer-board-table expanded-table board-table full-width-table"
                        >
                          <thead>
                            <tr>
                              <th>Invoice Name</th>
                              <th>SEBI No</th>
                              <th>Email</th>
                              <th>Download Invoice</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(invoice, index) in invoiceData.data"
                              :key="index"
                            >
                              <td>{{ invoice.name || "--" }}</td>
                              <td>{{ invoice.sebi_no || "--" }}</td>
                              <td>{{ invoice.email || "--" }}</td>
                              <td>
                                <i
                                  class="el-icon-bottom download-btn"
                                  style="font-size: 13px; margin-left:40px"
                                  v-if="invoice.invoice_url"
                                  @click="downloadPdf(invoice.invoice_url)"
                                ></i>
                              </td>
                            </tr>
                          </tbody>
                        </table>

                        <!-- invoice Pagination -->
                        <div
                          class="invoice-pagination"
                          style="text-align:center; margin-top: 20px;"
                        >
                          <el-pagination
                            @current-change="handleInvoicePageChange"
                            @size-change="handleInvoicePageSizeChange"
                            :current-page="invoicePagination.current_page"
                            :page-sizes="[5, 10, 20, 50]"
                            :page-size="invoicePagination.page_size"
                            :total="invoicePagination.total_entries"
                            layout="total, prev, pager, next"
                          ></el-pagination>
                        </div>
                      </div>
                    </td>
                  </tr>
                </template>
              </tbody>
            </table>
          </div>
          <div class="pagination" style="text-align:center">
            <el-pagination
              @current-change="handleCurrentChange"
              :current-page="pagination.current_page"
              :page-sizes="[5, 10, 20, 50]"
              :page-size="pagination.page_size"
              :total="pagination.total_entries"
              :pager-count="5"
              layout="total, prev, pager, next"
            ></el-pagination>
          </div>
        </div>
       <div v-if="(activeBtn === 'login' || activeBtn === 'premium') && !is_user_list_loading && !subscribedUsersList.length">
  <NoDataFound></NoDataFound>
</div>

        <!-- Table for Chat tab -->
        <div v-if="activeBtn === 'chat' && (chatUsersList.length || is_chat_list_loading)" v-loading="is_chat_list_loading" >
  <div class="board-table-outer">
    <table class="outer-board-table board-table">
      <thead>
        <tr class="main-head">
          <th>Reference</th>
          <th style="min-width: 150px;">Name</th>
          <th style="min-width: 150px;">UTM Source</th>
          <th style="min-width: 150px;">Email</th>
          <th style="min-width: 90px;">Mobile</th>
          <th style="min-width: 150px;">Expert (Chat with)</th>
          <th style="min-width: 150px;">Chat Payment Time</th>
          <th style="min-width: 150px;" @click="sortByLastLogin">
            Chat Initiated Time
            <span>
              <i
                v-if="sortOrder === 'asc'"
                class="el-icon-arrow-up"
                style="color: black;"
              ></i>
              <i
                v-else
                class="el-icon-arrow-down"
                style="color: black;"
              ></i>
            </span>
          </th>
          <th style="min-width: 150px;">Expert Entry Time</th>
          <th style="min-width: 150px;">Expert Exit Time</th>
          <th style="min-width: 150px;">User Entry Time</th>
          <th style="min-width: 150px;">User Exit Time</th>
          <th style="min-width: 120px;">Chat Status</th>
          <th style="min-width: 150px;">First Chat</th>
          <th style="min-width: 150px;">Latest Chat</th>
          <th>Number of Chats</th>
          <th style="min-width: 60px;">Review</th>
          <th style="min-width: 100px;">Session Balance</th>
          <th>Transcript</th>
          <th style="min-width: 100px;" class="text-center fixed-column">
            WhatsApp
            <span class="shadow"></span>
          </th>
        </tr>
      </thead>

      <tbody>
        <tr v-for="data in chatUsersList" :key="data.session_id">
          <td>
            <a
              v-if="data.invoice_url"
              :href="data.invoice_url"
              target="_blank"
              class="external-link-color"
              style="text-decoration: underline;" 
            >
              {{ data.invoice_no }}
            </a>
            <span v-else>--</span>
          </td>
          <td>{{ data.user_name || "--" }}</td>
          <td>{{ data.utm_source || "--" }}</td>
          <td>
            <span
              v-if="data.email"
              class="external-link-color"
              @click="handleEmailClick(data.email)"
              style="text-decoration: underline; cursor: pointer;"
            >
              {{ data.email }}
            </span>
            <span v-else>--</span>
          </td>
          <td>{{ data.mobile || "--" }}</td>
          <td>{{ data.expert_name || "--" }}</td>

          <td>
            {{
              data.chat_payment_time
                ? moment(data.chat_payment_time).format("MMM DD YYYY, h:mm A")
                : "--"
            }}
          </td>
          <td>
            {{
              data.chat_initiated_time
                ? moment(data.chat_initiated_time).format("MMM DD YYYY, h:mm A")
                : "--"
            }}
          </td>

          <td>
            {{
              data.expert_entry_time
                ? moment(data.expert_entry_time).format("MMM DD YYYY, h:mm A")
                : "--"
            }}
          </td>

          <td>
            {{
              data.expert_exit_time
                ? moment(data.expert_exit_time).format("MMM DD YYYY, h:mm A")
                : "--"
            }}
          </td>

          <td>
            {{
              data.user_entry_time
                ? moment(data.user_entry_time).format("MMM DD YYYY, h:mm A")
                : "--"
            }}
          </td>

          <td>
            {{
              data.user_exit_time
                ? moment(data.user_exit_time).format("MMM DD YYYY, h:mm A")
                : "--"
            }}
          </td>

          <td>{{ data.chat_status || "--" }}</td>

          <td>
            {{
              data.first_chat
                ? moment(data.first_chat).format("MMM DD YYYY, h:mm A")
                : "--"
            }}
          </td>

          <td>
            {{
              data.latest_chat
                ? moment(data.latest_chat).format("MMM DD YYYY, h:mm A")
                : "--"
            }}
          </td>

          <td>{{ data.no_of_chats || "--" }}</td>

         <td>
  <span
    v-if="data.review && data.review.userLikeExperience"
    @click="openReviewDialog(data.review)"
    style="cursor: pointer; text-decoration: underline; color: #409EFF;"
  >
    {{ data.review.userLikeExperience }}
  </span>
  <span v-else>--</span>
</td>


          <td>{{ data.remaining_chat_session || 0 }}</td>

          <td style="text-align:center">
            <a
              v-if="data.transcript"
              :href="data.transcript"
              target="_blank"
             class="el-icon-bottom font-weight-700 download-btn"
              style="text-decoration: underline;"
            >
            </a>
            <span v-else>--</span>
          </td>
          <td class="flex-center fixed-column">
            <img
              src="../assets/images/whatsapp.png"
              width="25px"
              alt="WA"
              @click="openWhatsApp(data.mobile)"
              style="cursor: pointer;"
            />
            <span class="shadow"></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="pagination" style="text-align:center">
    <el-pagination
      @current-change="handleChatPageChange"
      :current-page="chatPagination.current_page"
      :page-sizes="[5, 10, 20, 50]"
      :page-size="chatPagination.page_size"
      :total="chatPagination.total_entries"
      :pager-count="5"
      layout="total, prev, pager, next"
    ></el-pagination>
  </div>
</div>

<div v-if="activeBtn === 'chat' && !is_chat_list_loading && !chatUsersList.length">
  <NoDataFound></NoDataFound>
</div>

      </div>
      <!-- Below dialog for user Device details -->
      <el-dialog
        :visible.sync="dialogDeviceTableVisible"
        title="User Device Details"
        class="custom-dialog"
        :width="'70%'"
      >
        <div
          v-if="dialogDeviceTableData.length || is_device_list_loading"
          v-loading="is_device_list_loading"
        >
          <el-table
            :data="dialogDeviceTableData"
            v-loading="is_device_list_loading"
          >
            <el-table-column
              prop="device_unique_id"
              label="Device Unique ID"
              min-width="250px"
            ></el-table-column>
            <el-table-column
              prop="platform"
              label="Platform"
              min-width="180px"
            ></el-table-column>
            <el-table-column
              prop="timezone"
              label="Timezone"
              min-width="180px"
            ></el-table-column>
            <el-table-column
              prop="device_type"
              label="Device Type"
              min-width="180px"
            ></el-table-column>
          </el-table>
          <div class="pagination" style="text-align:center; margin-top: 20px;">
            <el-pagination
              @current-change="handleDeviceDialogCurrentChange"
              :current-page="devicePagination.current_page"
              :page-size="devicePagination.page_size"
              :total="devicePagination.total_entries"
              :pager-count="5"
              layout="prev, pager, next"
            ></el-pagination>
          </div>
        </div>
        <div v-if="!is_device_list_loading && !dialogDeviceTableData.length">
          <NoDataFound></NoDataFound>
        </div>
      </el-dialog>

 <!-- Below dialog for user Review details -->
      <el-dialog
  title="User Review"
  :visible.sync="reviewDialogVisible"
  width="400px"
  :close-on-click-modal="false"
  custom-class="review-popup"
  :show-close="false"
>
  <!-- close button -->
  <span class="custom-close" @click="reviewDialogVisible = false">×</span>

  <div class="review-content">
    <div v-if="selectedReview && selectedReview.reviewOptions && selectedReview.reviewOptions.length">
      <ul class="review-list">
        <li v-for="(option, index) in selectedReview.reviewOptions" :key="index">
          {{ option }}
        </li>
      </ul>
    </div>
    <div v-else class="no-review-msg">-- No review options found --</div>
  </div>
</el-dialog>


    </div>

    <div v-else>
      <div class="cover-page-container">
        <div class="block-mob-view">
          To access the Dashboard Analytics, please log in via desktop for an
          enhanced user experience.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
var echarts = require("echarts");
import { serverAddr, serverHostName, serverAddrForCSV, serverAddrForChat, chatServerHostName } from "../networkConfig";
import { graphData } from "../mixins/AnalyticsGraphData";
import { filterCallBack } from "../mixins/filter";
import PlainSideBar from "@/components/PlainSideBar.vue";
import MobileNav from "@/components/MobileNav.vue";
import Hexagon from "@/components/Hexagon.vue";
import NoDataFound from "@/components/NoDataFound.vue";
import { screenSize } from "../mixins/ScreenSize.js";
import { required } from "vuelidate/lib/validators";
import CripNotice from "crip-vue-notice";
import { HelperNetworkCallBack } from "../mixins/Helper";
import moment from "moment";
import ExcelJS from "exceljs";
import axios from "axios";

export default {
  name: "SADashboardAnalytics",

  mixins: [filterCallBack, graphData, screenSize, HelperNetworkCallBack],

  components: {
    PlainSideBar,
    MobileNav,
    Hexagon,
    NoDataFound,
  },

  data() {
    return {
      nav_title: "Expert's Analytics",
      serverHostName: serverHostName,
      chatServerHostName: chatServerHostName,
      moment: moment,
      pickerOptions: {
        shortcuts: [
          {
            text: "Last week",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last month",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "Last 3 months",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      value1: "",
      value2: "",
      subscribedUsersList: [],

      status_list: [
        { label: "Live", value: "Live" },
        { label: "Expired", value: "Expired" },
      ],
      status: "",
      pagination: [],
      currentPage: 1,
      startDate: "", // no preselected date
      endDate: "", // no preselected date
      defaultStartDate: new Date(
        new Date().setMonth(new Date().getMonth() - 1)
      ), // default view of the previous month
      defaultEndDate: new Date(), // default view of the current month,
      // endDatePickerOptions: {
      //   disabledDate(time) {
      //     return time > new Date(); // disable dates in the future
      //   }
      // },
      active_period: "1M",
      period_list: [
        {
          label: "1 Month",
          value: "1M",
        },
        {
          label: "3 Month",
          value: "3M",
        },
        {
          label: "6 Month",
          value: "6M",
        },
        {
          label: "1 Year",
          value: "1Y",
        },
      ],
      kycStatus: "",
      subscribedPlans: "",
      kyc_status_list: ["KYC Verified", "KYC Not Verified"],
      plan_name_list: ["Premium", "Lite", "Pro"],
      is_user_list_loading: false,
      is_export_Loading: false,
      exportUserList: [],
      brokerList: [],
      searchQuery: "",
      selectedBroker: "",
      selectedEmail: "",
      sortOrder: "asc",
      dialogDeviceTableVisible: false,
      dialogDeviceTableData: [],
      devicePagination: {
        current_page: 1,
        page_size: 5,
        total_entries: 0,
      },
      is_device_list_loading: false,
      selected_user_id: null,
      invoiceData: {
        data: [],
      },
      invoicePagination: {
        total_entries: 0, 
        total_pages: 0,
        current_page: 1, 
        page_size: 4, 
      },
      expandedPlanId: null,
      is_user_list_loading: false,
         activeBtn: 'login',
      buttons: [
        { name: 'login', label: 'Login' },
        { name: 'premium', label: 'Premium' },
        { name: 'chat', label: 'Chat' },
      ],
       chatUsersList: [],
    is_chat_list_loading: false,
    chatPagination: {
      current_page: 1,
      page_size: 10,
      total_entries: 0,
    },
    reviewDialogVisible: false,
    selectedReview: null,
    };
  },

  validations: {
    // review_title: {
    //     required
    // },
    review: {
      required,
    },
  },

  mounted() {
    this.getBrokerList();
    this.getSubscribedUsersList();
     this.getChatUsersList();
  },
  watch: {
     activeBtn(newVal) {
      if (newVal === "login" || newVal === "premium") this.getSubscribedUsersList();
      else if (newVal === "chat") this.getChatUsersList();
    },
    user_details(newValue, oldValue) {
      if (
        newValue &&
        newValue.mark_as_verified &&
        newValue.is_active_ra &&
        this.isDesktop
      ) {
        this.getSubscribedUsersList();
      }
    },
    selectedDateRange() {
      this.filterUserData(); // Fetch data when date range changes
    },
    startDate(newValue, oldValue) {
      if (newValue) {
        this.startDate = this.formatDate(newValue);
      }
      if (newValue == null) {
        this.startDate = "";
      }
    },
    endDate(newValue, oldValue) {
      if (newValue) {
        this.endDate = this.formatDate(newValue);
      }
      if (newValue == null) {
        this.endDate = "";
      }
    },
  },

  methods: {
    handleExportBasedOnTab() {
  if (this.activeBtn === 'premium' || this.activeBtn === 'login') {
    this.getTotalEntriesForExport();
  } else if (this.activeBtn === 'chat') {
    this.getTotalChatEntriesForExport();
  }
},
    openReviewDialog(review) {
    this.selectedReview = review;
    this.reviewDialogVisible = true;
  },
    getChatUsersList() {
      this.is_chat_list_loading = true;
      const obj = {
        page_no: this.chatPagination.current_page,
        page_per_entries: this.chatPagination.page_size,
        // status: this.status,
        // start_date: this.startDate,
        // end_date: this.endDate,
        // kyc_status: this.kycStatus,
        // plan_name: this.subscribedPlans,
        // broker: this.selectedBroker,
        // is_export: false,
        // email_id: this.selectedEmail,
        // q: this.searchQuery,
      };

      serverAddrForChat.post("/v1/chat/sa_dashboard", obj)
        .then((response) => {
          if (response.data.status) {
            this.chatUsersList = response.data.data;
            this.chatPagination = response.data.pagination;
          }
          setTimeout(() => {
            this.is_chat_list_loading = false;
          }, 100);
        })
        .catch((error) => {
          console.log(error);
          this.is_chat_list_loading = false;
        });
    },

    handleCurrentChange(val) {
      this.pagination.current_page = val;
      this.getSubscribedUsersList();
    },

    handleChatPageChange(val) {
    this.chatPagination.current_page = val;
    this.getChatUsersList();
  },
    changeTab(tab) {
    this.activeBtn = tab;

    if (tab === 'login' || tab === 'premium') {
      this.getSubscribedUsersList();
    } else if (tab === 'chat') {
      this.getChatUsersList(); 
    }
  },
 
    downloadPdf(path) {
      window.open(`${this.serverHostName + "/" + path}`, "_blank");
    },
    toggleExpand(planId) {
      if (this.expandedPlanId === planId) {
        // Collapse the row if already expanded
        this.expandedPlanId = null;
        this.invoiceData = { data: [] }; // Clear the invoice data when collapsing
      } else {
        // Expand the row
        this.expandedPlanId = planId;
        this.getPlanInvoices(planId); // Fetch invoices for the expanded row
      }
    },

    getPlanInvoices(planId, page = 1, pageSize = 5) {
      this.is_user_list_loading = true;

      const params = {
        plan_id: planId,
        page_no: page,
        page_per_entries: pageSize,
      };

      serverAddr
        .get("/my_dashboard/v1/sa/get_ra_invoices_by_plan_id", { params })
        .then((response) => {
          if (response.data.status) {
            this.invoiceData.data = response.data.data;

            this.invoicePagination.total_entries =
              response.data.pagination.total_entries;
            this.invoicePagination.total_pages =
              response.data.pagination.total_pages;
            this.invoicePagination.current_page =
              response.data.pagination.current_page;
          } else {
            console.error("Error fetching invoices:", response.data.message);
            this.invoiceData.data = [];
            this.invoicePagination.total_entries = 0;
          }

          setTimeout(() => {
            this.is_user_list_loading = false;
          }, 100);
        })
        .catch((error) => {
          console.log("Error fetching invoice data:", error);
          this.is_user_list_loading = false;
        });
    },

    // Handle page change for invoice pagination
    handleInvoicePageChange(page) {
      this.invoicePagination.current_page = page;
      this.getPlanInvoices(
        this.expandedPlanId,
        page,
        this.invoicePagination.page_size
      );
    },

    // Handle page size change for invoice pagination
    handleInvoicePageSizeChange(pageSize) {
      this.invoicePagination.page_size = pageSize;
      this.invoicePagination.current_page = 1; 
      this.getPlanInvoices(
        this.expandedPlanId,
        this.invoicePagination.current_page,
        pageSize
      );
    },

    // Below methods for Device details
    openDialogWithDeviceData(user_id) {
      this.selected_user_id = user_id;
      this.dialogDeviceTableVisible = true;
      this.getDeviceData(
        user_id,
        this.devicePagination.current_page,
        this.devicePagination.page_size
      );
    },
    getDeviceData(user_id, page, pageSize) {
      this.is_device_list_loading = true;

      const queryParams = new URLSearchParams({
        user_id: user_id,
        page_no: page,
        page_per_entries: pageSize,
      });

      serverAddr
        .get(`/auth/admin/v1/user_device_details?${queryParams.toString()}`)
        .then((response) => {
          if (response.data.status) {
            this.dialogDeviceTableData = response.data.data;
            this.devicePagination.total_entries =
              response.data.pagination.total_entries;
          } else {
            this.dialogDeviceTableData = [];
            this.devicePagination.total_entries = 0;
          }
          setTimeout(() => {
            this.is_device_list_loading = false;
          }, 100);
        })
        .catch((error) => {
          console.error("Error fetching device data:", error);
          this.dialogDeviceTableData = [];
          this.is_device_list_loading = false;
        });
    },
    handleDeviceDialogCurrentChange(page) {
      this.devicePagination.current_page = page;
      this.getDeviceData(
        this.selected_user_id,
        page,
        this.devicePagination.page_size
      );
    },
    handleDeviceDialogSizeChange(pageSize) {
      this.devicePagination.page_size = pageSize;
      this.getDeviceData(
        this.selected_user_id,
        this.devicePagination.current_page,
        pageSize
      );
    },
    sortByLastLogin() {
      // sort by last login
      const compareFn = (a, b) => {
        const dateA = a.user_last_login ? new Date(a.user_last_login) : null;
        const dateB = b.user_last_login ? new Date(b.user_last_login) : null;

        if (this.sortOrder === "asc") {
          return dateA - dateB;
        } else {
          return dateB - dateA;
        }
      };

      // Sort the array
      this.subscribedUsersList.sort(compareFn);

      // Toggle sort order for next click
      this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
    },
    downloadBulkDetailsPdf() {
      var linkForDownload = `${
        this.serverHostName
      }/api/my_dashboard/v1/sa/download_invoice_SA_Dashboard?`;
      linkForDownload = this.status.length
        ? linkForDownload + "status=" + this.status
        : linkForDownload;
      linkForDownload =
        this.startDate != null && this.startDate.length
          ? linkForDownload + "&start_date=" + this.startDate
          : linkForDownload;
      linkForDownload =
        this.endDate != null && this.endDate.length
          ? linkForDownload + "&end_date=" + this.endDate
          : linkForDownload;

      linkForDownload = this.kycStatus.length
        ? linkForDownload + "&kyc_status=" + this.kycStatus
        : linkForDownload;

      linkForDownload = this.selectedBroker.length
        ? linkForDownload + "&broker=" + this.selectedBroker
        : linkForDownload;

      window.open(linkForDownload, "_blank");
    },
    openWhatsApp(mobile) {
      if (mobile != null) {
        var whatsappURL;
        if (window.innerWidth < 992) {
          // Construct the WhatsApp URL
          whatsappURL = `https://wa.me/${mobile}`;
        } else {
          whatsappURL = `https://web.whatsapp.com/send?phone=${mobile}`;
        }

        // Open the WhatsApp URL
        var newWindow = window.open(whatsappURL, "_blank");

        // Check if a new tab was opened
        if (
          !newWindow ||
          newWindow.closed ||
          typeof newWindow.closed == "undefined"
        ) {
          // If the window was blocked or closed, prompt the user to check their browser settings
          alert(
            "WhatsApp window was blocked or closed. Please check your browser settings to allow pop-ups or manage tabs."
          );
        }
      } else {
        new CripNotice({
          title: "Oops! Something went wrong!",
          description: "Mobile number not present",
          type: "error",
          duration: 3,
        });
      }
    },
    async checkLoginUserDetail() {
      const computedValue = this.user_details;
      if (
        computedValue &&
        computedValue.mark_as_verified &&
        computedValue.is_active_ra
      ) {
        this.getSubscribedUsersList();
      }
    },

    handleStartDateChange(val) {
      if (
        val != null &&
        this.endDate &&
        new Date(val) > new Date(this.endDate)
      ) {
        this.endDate = val;
      }

      if (this.startDate && this.endDate) {
        this.getSubscribedUsersList();
      }
    },
    handleEndDateChange(val) {
      if (
        val != null &&
        this.startDate &&
        new Date(val) < new Date(this.startDate)
      ) {
        this.startDate = val;
      }

      if (this.startDate && this.endDate) {
        this.getSubscribedUsersList();
      }
    },

    openStartDatePicker() {
      // Open the date picker with the past month visible
      const datePicker = this.$refs.startDatePicker;
      const prevMonth = new Date();
      prevMonth.setMonth(prevMonth.getMonth() - 1);
      datePicker.$refs.picker.currentView.date.setMonth(prevMonth.getMonth());
      datePicker.$refs.picker.currentView.date.setFullYear(
        prevMonth.getFullYear()
      );
      datePicker.$refs.picker.handleDatePick({
        type: "month",
        value: prevMonth,
      });
    },
    openEndDatePicker() {
      // Open the date picker with the current month visible
      const datePicker = this.$refs.endDatePicker;
      const currentMonth = new Date();
      datePicker.$refs.picker.currentView.date.setMonth(
        currentMonth.getMonth()
      );
      datePicker.$refs.picker.currentView.date.setFullYear(
        currentMonth.getFullYear()
      );
      datePicker.$refs.picker.handleDatePick({
        type: "month",
        value: currentMonth,
      });
    },
    formatDate(date) {
      return date ? moment(date).format("YYYY-MM-DD") : "";
    },

    filterUserData() {
      this.currentPage = 1;
      this.getSubscribedUsersList();
    },

    handleEmailClick(email) {
      this.selectedEmail = email;
      this.filterUserData();
    },

    handleCurrentChange(val) {
      this.currentPage = val;
      this.getSubscribedUsersList();
    },

    downloadPdf(path) {
      window.open(`${this.serverHostName + "/" + path}`, "_blank");
    },

    // Download excel for login / premium SA dashboard
  async downloadExcel() {
  this.is_export_Loading = true;
  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet(this.activeBtn === "login" ? "Login Users" : "Premium Users");

    // Define column mapping based on table headers
    let columns = [];
    if (this.activeBtn === "login") {
      columns = [
        { key: "user_name", header: "Name" },
        { key: "utm_source", header: "UTM Source" },
        { key: "email", header: "Email" },
        { key: "mobile", header: "Mobile" },
        { key: "pan_number", header: "Pan" },
        { key: "user_first_login", header: "First Login" },
        { key: "user_last_login", header: "Last Login" },
        { key: "no_of_logins", header: "Number of times user Login" },
        { key: "no_of_device_used", header: "Number of Device Used" },
      ];
    } else if (this.activeBtn === "premium") {
      columns = [
        { key: "invoice_url", header: "Invoice" },
        { key: "user_name", header: "Name" },
        { key: "utm_source", header: "UTM Source" },
        { key: "email", header: "Email" },
        { key: "mobile", header: "Mobile" },
        { key: "pan_number", header: "Pan" },
        { key: "first_subscription_datetime", header: "First Subscribed" },
        { key: "latest_subscription_datetime", header: "Latest Subscribed" },
        { key: "no_of_times_subscribed_earlier", header: "Number of Subscription" },
        { key: "plan_amount", header: "Price" },
        { key: "access_code_used_count", header: "Access Code Used (Count)" },
        { key: "brokers_connected", header: "Brokers Connected" },
      ];
    }

    // Add headers to worksheet
    worksheet.addRow(columns.map((col) => col.header));

    // Add data rows
    this.exportUserList.forEach((item) => {
      const row = columns.map(({ key }) => {
        let value = item[key];

        // Format only actual datetime fields
        const dateFields = [
          "user_first_login",
          "user_last_login",
          "first_subscription_datetime",
          "latest_subscription_datetime"
        ];

        if (dateFields.includes(key)) {
          return value ? moment(value).format("MMM DD YYYY, h:mm A") : "--";
        } else if (key === "invoice_url") {
          return item.invoice_url ? item.invoice_no || "Invoice" : "--";
        } else {
          return value !== null && value !== undefined && value !== "" ? value : "--";
        }
      });

      worksheet.addRow(row);
    });

    // Set column width
    worksheet.columns.forEach((col) => {
      col.width = 25;
    });

    // Create Excel file buffer
    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/octet-stream" });

    // Download it
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = `StockAnts_${this.activeBtn}_User_List.xlsx`;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting Excel:", error);
  }

  setTimeout(() => {
    this.is_export_Loading = false;
  }, 100);
},

// Download excel for Chat SA dashboard
async downloadChatExcel() {
  this.is_export_Loading = true;
  try {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Chat Users");

    const columns = [
      { key: "invoice_url", header: "Reference" },
      { key: "user_name", header: "Name" },
      { key: "utm_source", header: "UTM Source" },
      { key: "email", header: "Email" },
      { key: "mobile", header: "Mobile" },
      { key: "expert_name", header: "Expert (Chat with)" },
      { key: "chat_payment_time", header: "Chat Payment Time" },
      { key: "chat_initiated_time", header: "Chat Initiated Time" },
      { key: "expert_entry_time", header: "Expert Entry Time" },
      { key: "expert_exit_time", header: "Expert Exit Time" },
      { key: "user_entry_time", header: "User Entry Time" },
      { key: "user_exit_time", header: "User Exit Time" },
      { key: "chat_status", header: "Chat Status" },
      { key: "first_chat", header: "First Chat" },
      { key: "latest_chat", header: "Latest Chat" },
      { key: "no_of_chats", header: "Number of Chats" },
      { key: "review.userLikeExperience", header: "Review" },
      { key: "review.reviewOptions", header: "Review Options" },
      { key: "remaining_chat_session", header: "Session Balance" },
      { key: "transcript", header: "Transcript" },
    ];

    worksheet.addRow(columns.map(col => col.header));

    this.chatExportList.forEach((item) => {
      const row = columns.map(({ key }) => {
        const keys = key.split(".");
        let value = keys.reduce((obj, k) => (obj && obj[k] !== undefined ? obj[k] : null), item);

        // Format proper datetime fields
        const datetimeKeys = [
          "chat_payment_time",
          "chat_initiated_time",
          "expert_entry_time",
          "expert_exit_time",
          "user_entry_time",
          "user_exit_time",
          "first_chat",
          "latest_chat"
        ];

        if (datetimeKeys.includes(key)) {
          value = value ? moment(value).format("MMM DD YYYY, h:mm A") : "--";
        } else if (Array.isArray(value)) {
          value = value.join(", "); // for reviewOptions
        } else if (key === "invoice_url") {
          return item.invoice_url ? item.invoice_no || "Invoice" : "--";
        } else if (key === "transcript") {
          value = item.transcript ? "Available" : "--";
        } else if (value === 0) {
          value = "0";
        } else {
          value = value !== null && value !== undefined && value !== "" ? value : "--";
        }

        return value;
      });

      worksheet.addRow(row);
    });

    worksheet.columns.forEach((col) => {
      col.width = 25;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], { type: "application/octet-stream" });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "StockAnts_Chat_User_List.xlsx";
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(url);
  } catch (error) {
    console.error("Error exporting chat Excel:", error);
  }
  setTimeout(() => {
    this.is_export_Loading = false;
  }, 100);
},

    getBrokerList() {
      serverAddr
        .get("/my_dashboard/v1/sa/active_broker_details")
        .then((response) => {
          if (response.data.status) {
            this.brokerList = response.data.data;
          }
        })
        .catch(
          function(error) {
            console.log(error);
            this.is_user_list_loading = false;
          }.bind(this)
        );
    },

    clearFilters() {
      this.selectedDateRange = [];
      this.startDate = "";
      this.endDate = "";
      this.status = "";
      this.kycStatus = "";
      this.subscribedPlans = "";
      this.selectedBroker = "";
      this.currentPage = 1;
      this.selectedEmail = "";
      this.searchQuery = "";
      this.filterUserData();
    },
    isFilterActive() {
      if (
        (this.startDate && this.startDate.length) ||
        (this.endDate && this.endDate.length) ||
        this.status.length ||
        this.selectedBroker.length ||
        this.selectedEmail.length ||
        this.kycStatus.length ||
        this.subscribedPlans.length ||
        this.searchQuery.length
      ) {
        return true;
      } else {
        return false;
      }
    },
    getSubscribedUsersList() {
      this.is_user_list_loading = true;

      var obj = {};
      obj.page_no = this.currentPage;
      obj.page_per_entries = 10;
      obj.status = this.status;
      obj.start_date = this.startDate;
      obj.end_date = this.endDate;
      obj.kyc_status = this.kycStatus;
      obj.plan_name = this.subscribedPlans;
      obj.broker = this.selectedBroker;
      obj.is_export = false;
      obj.email_id = this.selectedEmail;
      obj.q = this.searchQuery;

      serverAddr
        .post("/my_dashboard/v1/sa_dashboard", obj)
        .then((response) => {
          if (response.data.status) {
            this.subscribedUsersList = response.data.data;
            this.pagination = response.data.pagination;
          } else {
          }
          setTimeout(() => {
            this.is_user_list_loading = false;
          }, 100);
        })
        .catch(
          function(error) {
            console.log(error);
            this.is_user_list_loading = false;
          }.bind(this)
        );
    },
    getTotalEntriesForExport() {
      var obj = {};
      obj.page_no = 1;
      obj.page_per_entries = this.pagination.total_entries;
      obj.status = this.status;
      obj.start_date = this.startDate;
      obj.end_date = this.endDate;
      obj.kyc_status = this.kycStatus;
      obj.plan_name = this.subscribedPlans;
      obj.broker = this.selectedBroker;
      obj.is_export = false;
      obj.email_id = this.selectedEmail;
      obj.q = this.searchQuery;

      this.is_export_Loading = true;

      serverAddr
        .post("/my_dashboard/v1/sa_dashboard", obj)
        .then((response) => {
          if (response.data.status) {
            this.exportUserList = response.data.data;
            this.downloadExcel();
          } else {
          }
          setTimeout(() => {
            this.is_export_Loading = false;
          }, 100);
        })
        .catch((error) => {
          console.log(error);
          this.is_export_Loading = false;
        });
    },

// For chat export
    getTotalChatEntriesForExport() {
  const obj = {
    page_no: 1,
    page_per_entries: this.chatPagination.total_entries,
    status: this.status,
    start_date: this.startDate,
    end_date: this.endDate,
    kyc_status: this.kycStatus,
    plan_name: this.subscribedPlans,
    broker: this.selectedBroker,
    is_export: true,
    email_id: this.selectedEmail,
    q: this.searchQuery,
  };

  this.is_export_Loading = true;

  serverAddrForChat.post("/v1/chat/sa_dashboard", obj)
    .then((response) => {
      if (response.data.status) {
        this.chatExportList = response.data.data; // store for export
        this.downloadChatExcel();
      }
      setTimeout(() => {
        this.is_export_Loading = false;
      }, 100);
    })
    .catch((error) => {
      console.log(error);
      this.is_export_Loading = false;
    });
}

  },

  computed: {
    isExportDisabled() {
  if (this.activeBtn === 'premium' || this.activeBtn === 'login') {
    return !this.subscribedUsersList.length || this.is_export_Loading;
  } else if (this.activeBtn === 'chat') {
    return !this.chatUsersList.length || this.is_export_Loading;
  }
  return true;
},

    //returns stored user profile from local storage
    userProfile() {
      return JSON.parse(localStorage.getItem("profile"));
    },

    // return user details e.g. accuracy, success rate, rating etc.
    user_details() {
      return this.$store.state.user_details;
    },

    //returns subscribed plan details from local storage
    subscribedPlanDetails() {
      return JSON.parse(localStorage.getItem("plan_details"));
    },

    startDatePickerOptions() {
      return {
        disabledDate: (time) => {
          const now = new Date();
          if (this.endDate) {
            return (
              time.getTime() > now.getTime() ||
              time.getTime() > new Date(this.endDate).getTime()
            );
          }
          return time.getTime() > now.getTime();
        },
      };
    },
    endDatePickerOptions() {
      return {
        disabledDate: (time) => {
          const now = new Date();
          if (this.startDate) {
            return (
              time.getTime() < new Date(this.startDate).getTime() ||
              time.getTime() > now.getTime()
            );
          }
          return time.getTime() > now.getTime();
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../css/variable.scss";
@import "../css/common.scss";

.SADashboardAnalytics {
  min-height: calc(100vh - 60px);
  background-color: $page-background-color;
  padding: 60px 0 0 0;

  .block-mob-view {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1.2rem;
    color: $secondary-theme-color;
    font-weight: 600;
    padding: 20px;
    text-align: center;
  }
  .outer {
    background-color: #feffe5;
    text-align: center;
    padding: 10px 0px 20px;
    width: calc(100% - 265px);
    margin-left: 265px;
  }
  .marquee-container img {
    max-height: 35px;
    margin-right: 60px;
    padding-top: 10px;
    padding-bottom: 10px;
  }

  // Below css for Marquee tag
  marquee {
    height: 100px;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    box-sizing: border-box;
    padding-top: 10px;
    padding-bottom: 10px;
    justify-content: center;
  }

  @keyframes marquee {
    0% {
      transform: translateX(100%);
    }

    100% {
      transform: translateX(-100%);
    }
  }
  .cover-page-container {
    .export-btn {
      font-size: 12px;
      padding: 4px 10px;
      margin-left: 8px;
    }
    .board-table-outer {
      border-top: 4px solid #bea66e;
      overflow-x: auto;
      min-height: 370px;

      .live {
        color: #079e3e;
      }

      .expired {
        color: #e72726;
      }
      .download-btn {
        padding: 5px 8px;
        font-size: 12px;
        width: 15px;
        margin: 0 auto;
        box-shadow: 0px 1px 3px 1px #e0e0e0;
      }
      .sub-section {
        padding: 0 !important;
      }
      .sub-sec-head {
        width: 100%;
        text-align: left;
        background-color: #2d2e8d;
        padding: 10px;
        color: #ffff;
        margin: 10px 0 0;
        font-weight: 600;
      }
    }
    .board-table {
      overflow-x: auto;
      border-spacing: 0;
      border-collapse: collapse;
      width: 100%;
      text-align: left;

      .main-head th {
        color: #000;
      }

      .border-right-gray {
        border-right: 1px solid #e9e9e9;
      }
      .border-bottom-gray {
        border-bottom: 1px solid #e9e9e9;
      }
      .bottom-spacing-table-heading {
        padding: 0px 8px 8px 8px;
      }
      thead {
        tr {
          th {
            color: #a5a6a8;
            font-size: 0.8rem;
            font-weight: 700;
            padding: 10px 20px;
            white-space: nowrap;
          }
        }

        tr:nth-child(1) {
          border-bottom: 1px solid #e9e9e9;
          background-color: #ededed;
        }
      }
      tbody {
        // min-height: 300px;
        tr {
          // cursor: pointer;
          td {
            font-size: 0.7rem;
            font-weight: 500;
            padding: 10px 15px;
            // vertical-align: unset;
          }
        }
        // tr:hover {
        //   background-color: #eff5fe;
        // }

        tr:nth-child(even) td {
          background-color: #f1f7f8; /* Set background color for even rows */
        }
      }
      td.fixed-column,
      th.fixed-column {
        position: sticky;
        right: -1px; /* Fix column to the right */
        z-index: 1;
        background-color: #ffff;
        border-bottom: none;
        height: 23px;
        border-left: 1px solid #dcdcdc !important;
        box-shadow: -4px 1px 5px -3px #00000080;
      }
    }

    .el-range-editor.el-input__inner {
      margin-right: 20px;
    }
    .pagination {
      margin: 15px 0 10px;
    }
    .user-details-section {
      border-bottom: 1px solid #d5d5d5;
      padding: 10px 20px;
    }

    .crown-outer {
      background: #bea66e;
      padding: 2px 5px;
      border-radius: 5px;
      margin-right: 3px;
    }
    .filter-section {
      padding: 0 20px;
      margin-bottom: 15px;
    }

    .button-row {
  display: flex;
  justify-content: flex-end;
  margin: 0px;
}
.button-group .btn {
  background-color: #e9f3ff;
  border: 1px solid #2488ff;
  color: #2488ff;
  padding: 6px 12px;
  cursor: pointer;
  border-radius: 0;
}
.button-group .btn:first-child {
  border-top-left-radius: 6px;
  border-bottom-left-radius: 6px;
}
.button-group .btn:last-child {
  border-top-right-radius: 6px;
  border-bottom-right-radius: 6px;
}
.button-group .btn.active {
  background-color: #2488ff;
  color: white;
}
  }

  .cover-page-container {
    width: calc(100% - 295px);
    margin-left: 280px;
    margin-top: 15px;
    padding-bottom: 10px;
    // padding: 20px 0;
    box-sizing: border-box;
    border-radius: 10px;
    background-color: #fff;
    box-shadow: 0px 0px 7px 1px #dcd6d6;
    margin-bottom: 50px;
  }

  .footer-section {
    width: calc(100% - 260px);
    margin-left: 260px;
  }

  @media screen and (max-width: 1283px) {
    .cover-page-container,
    .footer-section {
      width: 100%;
      margin-left: 0;
      height: calc(100vh - 160px);
      margin-top: 15px;
    }
    .cover-page-container {
      //   padding: 20px 10px 0 10px;
    }
    .sideBarSection {
      display: none;
    }
  }
}
</style>

<style lang="scss">
.SADashboardAnalytics {
  .NoDataFound {
    padding: 15px 0 0 0;
  }
  .review-card {
    border-radius: 10px;
    .el-card__body {
      padding: 5px 20px;
    }
  }
  .analytics-card {
    border-radius: 10px;
  }

  .review-section,
  .user-access-section {
    .el-rate__icon {
      font-size: 14px !important;
      margin-right: 2px;
    }
  }

  .referal-dialog {
    .el-dialog__header .el-dialog__title {
      color: #000;
      font-weight: 500;
    }
  }

  // Css for review popup
 .review-popup {
  border-radius: 10px;
  padding: 10px;
  position: relative;

  .custom-close {
    position: absolute;
    top: 12px;
    right: 15px;
    font-size: 20px;
    color: #999;
    cursor: pointer;
    font-weight: bold;
    z-index: 2;
    transition: color 0.2s;

    &:hover {
      color: #333;
    }
  }

  .review-content {
    font-size: 14px;
    color: #333;
    line-height: 1.6;
    padding: 10px 5px;

    .review-list {
      padding-left: 18px;
      margin: 0;

      li {
        margin-bottom: 8px;
        list-style-type: disc;
      }
    }

    .no-review-msg {
      text-align: center;
      font-style: italic;
      color: #999;
      padding: 10px 0;
    }
  }
}

  @media screen and (max-width: 992px) {
    .referal-dialog {
      width: 80% !important;
    }
  }
}
// Below css for user login & device details dialog box of
.custom-dialog .el-dialog__header {
  background-color: #f5f5f5;
  border-bottom: 1px solid #ebeef5;
  padding: 20px;
}

.custom-dialog .el-dialog__body {
  padding: 20px;
}

.custom-dialog .el-dialog__footer {
  border-top: 1px solid #ebeef5;
}

.custom-dialog .el-dialog {
  border-radius: 10px;
  overflow: hidden;
}

.custom-dialog .el-table {
  width: 100%;
}

.custom-dialog .el-table th {
  text-align: left;
  padding: 10;
}
.custom-dialog .el-table td {
  text-align: left;
  padding: 0;
}

.custom-dialog .el-dialog__wrapper {
  background-color: rgba(0, 0, 0, 0.5);
}
.custom-dialog {
  width: 100%;
}

// Below css for expanded row table data
.table-padding {
  padding: 20px;
  background-color: #fff;
}

.inner-table {
  border-radius: 8px;
  border: 1px solid #ebeef5;
  background-color: #fff;
  overflow: hidden;
  color: #303133;
}

.board-table-inner {
  td {
    border-bottom: 1px solid #e9e9e9;
    background-color: #fff; /* Ensuring table cell background is white */
  }
}

.board-table-outer {
  .sub-section {
    padding: 0 !important;
  }
  .sub-sec-head {
    width: 70%;
    text-align: left;
    background-color: #2d2e8d;
    padding: 10px;
    color: #ffff;
    margin: 10px 0 0;
    font-weight: 600;
  }
  .download-btn {
    padding: 5px 10px;
    font-size: 12px;
  }
}

.expanded-table {
  border-collapse: separate;
  border-spacing: 0;
  width: 100%;
  border: 1px solid #ccc;
  border-radius: 10px;
  background-color: white;
  overflow: hidden;
}

.expanded-table th,
.expanded-table td {
  padding: 10px;
  border-bottom: 1px solid #ddd;
  background-color: white;
}

.expanded-table thead {
  background-color: #f5f5f5;
}

.expanded-table tbody tr:last-child td {
  border-bottom: none;
}
</style>
